import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    clienteId: 0,
    cliente: null,
    clienteNombre: null,
    rubroTrabajoId: 0,
    rubroTrabajo: null,
    rubroTrabajoNombre: null,
    rubroTrabajoDescripcion: '',
    categoriaServicioId: 0,
    categoriaServicio: null,
    categoriaServicioNombre: null,
    pjeRentabilidadMinima: 0,
    cantidad: 0,
    monedaId: 0,
    moneda: null,
    monedaNombre: null,
    costoEstimado: 0,
    costoEstimadoTotal: 0,
    costoUnitario: false,
    costoInterno: 0,
    pjeRentabilidad: 0,
    cotizacionInterna: 0,
    cotizacion: 0,
    discriminarCategoriaServicio: false,
    pjeRecargoServicioPropio: 0,
    /* Parámetros para el cálculo del costo interno */
    parametrosGlobales: true,
    pjeGastosFijos: 0,
    pjeInversionFutura: 0,
    pjeImpuestosInternos: 0,
    pjeGastosFijosRubro: 0,
    pjeInversionFuturaRubro: 0,
    pjeImpuestosInternosRubro: 0,
    
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.clienteId = 0;
        state.cliente = null;
        state.clienteNombre = null;
        state.rubroTrabajoId = 0;
        state.rubroTrabajo = null;
        state.rubroTrabajoNombre = null;
        state.rubroTrabajoDescripcion = '';
        state.categoriaServicioId = 0;
        state.categoriaServicio = null;
        state.categoriaServicioNombre = null;
        state.pjeRentabilidadMinima = 0;
        state.cantidad = 0;
        state.monedaId = 101;
        state.moneda = {
            id: 101,
            nombre: 'PESOS'
        };
        state.monedaNombre = 'PESOS';
        state.costoEstimado = 0;
        state.costoEstimadoTotal = 0;
        state.costoUnitario = false;
        state.costoInterno = 0;
        state.pjeRentabilidad = 0;
        state.cotizacionInterna = 0;
        state.cotizacion = 0;
        /* Parámetros para el cálculo del costo interno */
        state.parametrosGlobales = true;
        state.pjeGastosFijos = 0;
        state.pjeInversionFutura = 0;
        state.pjeImpuestosInternos = 0;
        state.pjeGastosFijosRubro = 0;
        state.pjeInversionFuturaRubro = 0;
        state.pjeImpuestosInternosRubro = 0;

        state.discriminarCategoriaServicio = false;
        state.pjeRecargoServicioPropio = 0;
    },
    'SET_PARAMETROS' (state, params) {
        state.pjeRentabilidadParametro = params.pjeMargenOrdenTrabajo;
    },
    'SET_PARAMETROS_PRESUPUESTO'(state, params) {
        state.parametrosGlobales = true;
        state.pjeGastosFijos = params.pjeGastosFijos;
        state.pjeInversionFutura = params.pjeInversionFutura;
        state.pjeImpuestosInternos = params.pjeImpuestosInternos;
        state.pjeGastosFijosRubro = 0;
        state.pjeInversionFuturaRubro = 0;
        state.pjeImpuestosInternosRubro = 0;
        state.pjeIva = params.pjeIva;
    },
    'SET_PARAMETROS_CLIENTE'(state, params) {
        state.discriminarCategoriaServicio = params.discriminarCategoriaServicio;
        state.pjeRecargoServicioPropio = params.pjeRecargoServicioPropio;

        if ((/true/i).test(params.parametrosCostoInterno)) {
            state.pjeGastosFijos = params.pjeGastosFijos;
            state.pjeInversionFutura = params.pjeInversionFutura;
            state.pjeImpuestosInternos = params.pjeImpuestosInternos;
        }
    },
    'SET_CLIENTE'(state, cliente) {
        state.cliente = cliente;
        if (cliente) {
            state.clienteId= cliente.id? cliente.id : 0;
            state.clienteNombre= cliente.nombre? cliente.nombre.trim() : null;
        } else {
            state.clienteId= 0;
            state.clienteNombre= null;
        }

        state.rubros = [];
        state.rubrosList = [];

        /* Reinicializamos los valores de la orden a cotizar */
        state.rubroTrabajoId= 0;
        state.rubroTrabajo = null;
        state.rubroTrabajoNombre= null;
        state.rubroTrabajoDescripcion= '';
        state.categoriaServicioId = 0;
        state.categoriaServicio = null;
        state.categoriaServicioNombre = null;
        state.pjeRentabilidadMinima = 0;
        state.cantidad = 0;
        state.monedaId = 101;
        state.moneda = {
            id: 101,
            nombre: 'PESOS'
        };
        state.monedaNombre = 'PESOS';
        state.costoEstimado = 0;
        state.costoEstimadoTotal = 0;
        state.costoUnitario = false;
        state.costoInterno = 0;
        state.pjeRentabilidad = 0;
        state.cotizacionInterna = 0;
        state.cotizacion = 0;
    },
    'SET_RUBRO_TRABAJO'(state, rubro) {
        let loadRubro = false;
        if (rubro) {
            loadRubro = true;
        }

        if (loadRubro) {

            if (rubro.id != state.rubroTrabajoId) {
                state.rubroTrabajoId= rubro.id;
                state.rubroTrabajo = rubro;
                state.rubroTrabajoNombre= rubro.nombre.trim();
                state.rubroTrabajoDescripcion= rubro.descripcion.trim();
        
                state.pjeRentabilidad = parseFloat(state.pjeRentabilidadParametro);
                state.pjeRentabilidadMinima = parseFloat(rubro.pjeMargenMinimo);

                /* Parámetros para el cálculo del costo interno */
                state.parametrosGlobales = (/true/i).test(rubro.parametrosGlobales);
                state.pjeGastosFijosRubro = parseFloat(rubro.pjeGastosFijos);
                state.pjeInversionFuturaRubro = parseFloat(rubro.pjeInversionFutura);
                state.pjeImpuestosInternosRubro = parseFloat(rubro.pjeImpuestosInternos);
            }
        } else {
            state.rubroTrabajoId= 0;
            state.rubroTrabajo = null;
            state.rubroTrabajoNombre= null;
            state.rubroTrabajoDescripcion= '';
    
            state.pjeRentabilidad = 0;
            state.pjeRentabilidadMinima = 0;

            /* Parámetros para el cálculo del costo interno */
            state.parametrosGlobales = true;
            state.pjeGastosFijosRubro = 0;
            state.pjeInversionFuturaRubro = 0;
            state.pjeImpuestosInternosRubro = 0;
        }
    },
    'SET_CATEGORIA_SERVICIO'(state, categoriaServicio) {
        state.categoriaServicio = categoriaServicio;
        if (categoriaServicio) {
            state.categoriaServicioId= categoriaServicio.id? categoriaServicio.id : 0;
            state.categoriaServicioNombre= categoriaServicio.nombre? categoriaServicio.nombre.trim() : null;
        } else {
            state.categoriaServicioId= 0;
            state.categoriaServicioNombre= null;
        }

        state.cotizacion = state.cotizacionInterna;
        
        if (state.categoriaServicioId == 1) {
            if (state.pjeRecargoServicioPropio != 0) {
                state.cotizacion = Math.ceil(parseFloat(state.cotizacionInterna) 
                    + (parseFloat(state.cotizacionInterna) * parseFloat(state.pjeRecargoServicioPropio) / 100));
            }
        }
    },
    'CALCULAR_COSTO_UNITARIO'(state) {
        if (state.cantidad != 0) {
            state.costoEstimado = helpers.methods.roundToTwo(state.costoEstimadoTotal / state.cantidad);
        } else {
            state.costoEstimado = 0;
        }

        let pjeGastosFijos = parseFloat(state.pjeGastosFijos);
        let pjeInversionFutura = parseFloat(state.pjeInversionFutura);
        let pjeImpuestosInternos = parseFloat(state.pjeImpuestosInternos);

        if (!state.parametrosGlobales) {
            pjeGastosFijos = parseFloat(orden.pjeGastosFijosRubro);
            pjeInversionFutura = parseFloat(orden.pjeInversionFuturaRubro);
            pjeImpuestosInternos = parseFloat(orden.pjeImpuestosInternosRubro);
        }

        state.costoInterno = parseFloat(state.costoEstimadoTotal) 
            + (parseFloat(state.costoEstimadoTotal) * parseFloat(pjeGastosFijos) / 100) 
            + (parseFloat(state.costoEstimadoTotal) * parseFloat(pjeInversionFutura) / 100)
            + (parseFloat(state.costoEstimadoTotal) * parseFloat(pjeImpuestosInternos) / 100);
        
        state.cotizacionInterna = Math.ceil(parseFloat(state.costoInterno) / (1 - parseFloat(state.pjeRentabilidad) / 100));
        state.cotizacion = state.cotizacionInterna;

        if (state.categoriaServicioId == 1) {
            if (state.pjeRecargoServicioPropio != 0) {
                state.cotizacion = Math.ceil(parseFloat(state.cotizacionInterna) 
                    + (parseFloat(state.cotizacionInterna) * parseFloat(state.pjeRecargoServicioPropio) / 100));
            }
        }
    },
    'CALCULAR_COSTO_TOTAL'(state) {
        state.costoEstimadoTotal = helpers.methods.roundToTwo(state.costoEstimado * state.cantidad);

        let pjeGastosFijos = parseFloat(state.pjeGastosFijos);
        let pjeInversionFutura = parseFloat(state.pjeInversionFutura);
        let pjeImpuestosInternos = parseFloat(state.pjeImpuestosInternos);

        if (!state.parametrosGlobales) {
            pjeGastosFijos = parseFloat(orden.pjeGastosFijosRubro);
            pjeInversionFutura = parseFloat(orden.pjeInversionFuturaRubro);
            pjeImpuestosInternos = parseFloat(orden.pjeImpuestosInternosRubro);
        }

        state.costoInterno = parseFloat(state.costoEstimadoTotal) 
            + (parseFloat(state.costoEstimadoTotal) * parseFloat(pjeGastosFijos) / 100) 
            + (parseFloat(state.costoEstimadoTotal) * parseFloat(pjeInversionFutura) / 100)
            + (parseFloat(state.costoEstimadoTotal) * parseFloat(pjeImpuestosInternos) / 100);
        
        state.cotizacionInterna = Math.ceil(parseFloat(state.costoInterno) / (1 - parseFloat(state.pjeRentabilidad) / 100));
        state.cotizacion = state.cotizacionInterna;
        
        if (state.categoriaServicioId == 1) {
            if (state.pjeRecargoServicioPropio != 0) {
                state.cotizacion = Math.ceil(parseFloat(state.cotizacionInterna) 
                    + (parseFloat(state.cotizacionInterna) * parseFloat(state.pjeRecargoServicioPropio) / 100));
            }
        }
    },
    'UPDATE_PJE_RENTABILIDAD' (state) {
        // state.pjeRentabilidad = parseFloat(pjeRentabilidad);

        /* Rentabilidad a partir de la cotización */
        state.cotizacionInterna = 0;
            
        if (parseFloat(state.pjeRentabilidad) != 0) {
            state.cotizacionInterna = Math.ceil(parseFloat(state.costoInterno) / (1 - parseFloat(state.pjeRentabilidad) / 100));
        }

        state.cotizacion = state.cotizacionInterna;
        
        if (state.categoriaServicioId == 1) {
            if (state.pjeRecargoServicioPropio != 0) {
                state.cotizacion = Math.ceil(parseFloat(state.cotizacionInterna) 
                    + (parseFloat(state.cotizacionInterna) * parseFloat(state.pjeRecargoServicioPropio) / 100));
            }
        }
    },
    'SET_COTIZACION' (state, cotizacion) {
        state.cotizacion = parseFloat(cotizacion);
        
        /* Calcular a partir del pje de recargo */
        state.cotizacionInterna = parseFloat(cotizacion);

        /* Rentabilidad a partir de la cotización */
        state.pjeRentabilidad = 0;

        if (cotizacion != 0) {
            state.pjeRentabilidad = helpers.methods.roundToTwo((cotizacion - state.costoInterno) / cotizacion * 100); 
        }
    },
    'SET_COTIZACION_INTERNA' (state, cotizacionInterna) {
        state.cotizacionInterna = parseFloat(cotizacionInterna);
        
        /* Calculamos la cotizacion a partir de la cotizacion interna */
        state.cotizacion = parseFloat(cotizacionInterna);

        if (state.categoriaServicioId == 1) {
            if (state.pjeRecargoServicioPropio != 0) {
                state.cotizacion = Math.ceil(parseFloat(state.cotizacionInterna) 
                    + (parseFloat(state.cotizacionInterna) * parseFloat(state.pjeRecargoServicioPropio) / 100));
            }
        }

        /* Rentabilidad a partir de la cotización */
        state.pjeRentabilidad = 0;

        if (state.cotizacion != 0) {
            state.pjeRentabilidad = helpers.methods.roundToTwo((state.cotizacion - state.costoInterno) / state.cotizacion * 100); 
        }
    },
    'SET_MONEDA'(state, moneda) {
        state.moneda = moneda;
        if (moneda) {
            state.monedaId = moneda.id? moneda.id : 0;
            state.monedaNombre = moneda.nombre? moneda.nombre.trim() : null;
        } else {
            state.monedaId = 0;
            state.monedaNombre = null;
        }
    },
    'SET_RUBROS_TRABAJOS'(state, params) {
        state.rubros = params.rubros;
        state.rubrosList = params.rubrosList;
    },
};

const getters = {
    getField,

    rubros() {
        return state.rubros;
    },
    rubrosList() {
        return state.rubrosList;
    }
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            /* Recuperamos el margen inicial (parametro general) */
            apiAxios.get('ordenestrabajos/parametros' ) 
                .then(res => {
                    commit('SET_PARAMETROS', res.data);

                    /* Inicializamos la información del presupuesto */
                    return apiAxios.get('presupuestosinternos/inicializar')
                })
                .then(res => {
                    commit('SET_PARAMETROS_PRESUPUESTO', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    setCliente: ( { commit, state, dispatch, rootState }, cliente) => {
        return new Promise((resolve, reject) => {
            commit('SET_CLIENTE', cliente);
            
            dispatch('cliente/inicializar', cliente.id, { root: true} )
                .then(() => {
                    let params = {
                        discriminarCategoriaServicio: rootState.cliente.discriminarCategoriaServicio,
                        pjeRecargoServicioPropio: rootState.cliente.pjeRecargoServicioPropio,
                        parametrosCostoInterno: rootState.cliente.parametrosCostoInterno,
                        pjeGastosFijos: rootState.cliente.pjeGastosFijos,
                        pjeInversionFutura: rootState.cliente.pjeInversionFutura,
                        pjeImpuestosInternos: rootState.cliente.pjeImpuestosInternos,
                    }

                    commit('SET_PARAMETROS_CLIENTE', params);

                    /* Recuperamos la info de rubros de trabajo del cliente */
                    return dispatch('rubrostrabajos/getRubrosClienteList', state.clienteId, {root: true});
                })
                .then(() => {
                    let params = {
                        rubros: rootState.rubrostrabajos.rubrosList,
                        rubrosList: rootState.rubrostrabajos.rubrosSelectList
                    }
                    
                    commit('SET_RUBROS_TRABAJOS', params);
                    resolve();
                })
                .catch(() => {
                    reject('Se produjo un error al recuperar la información de rubros de trabajo.');
                })
        })
    },
    setRubroTrabajo: ( {commit }, rubroTrabajo) => {
        return new Promise((resolve, reject) => {
            commit('SET_RUBRO_TRABAJO', rubroTrabajo);
            resolve();
        })
    },
    setCategoriaServicio: ( {commit }, categoriaServicio) => {
        return new Promise((resolve, reject) => {
            commit('SET_CATEGORIA_SERVICIO', categoriaServicio);
            resolve();
        })
    },
    setMoneda: ( {commit }, moneda) => {
        return new Promise((resolve, reject) => {
            commit('SET_MONEDA', moneda);
            resolve();
        })
    },
    calcularCostoUnitario: ( {commit }) => {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_COSTO_UNITARIO');
            resolve();
        })
    },
    calcularCostoTotal: ( {commit }) => {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_COSTO_TOTAL');
            resolve();
        })
    },
    updatePjeRentabilidad: ( { commit }) => {
        return new Promise((resolve, reject) => {
            commit('UPDATE_PJE_RENTABILIDAD');
            resolve();
        })
    },
    setCotizacion: ( { commit }, cotizacion) => {
        return new Promise((resolve, reject) => {
            commit('SET_COTIZACION', cotizacion);
            resolve();
        })
    },
    setCotizacionInterna: ( { commit }, cotizacionInterna) => {
        return new Promise((resolve, reject) => {
            commit('SET_COTIZACION_INTERNA', cotizacionInterna);
            resolve();
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}